import MarkdownIt from 'markdown-it';

export function blockMathPlugin(md: MarkdownIt) {
    md.block.ruler.before('html_block', 'block_math', function (state, startLine, _endLine, silent) {
        const pos = state.bMarks[startLine] + state.tShift[startLine];
        const max = state.eMarks[startLine];

        // Check if line starts with our specific div
        const line = state.src.slice(pos, max);
        const match = line.match(/^<div\s+data-latex="([^"]+)"\s+data-type="block-math"\s*\/>\s*$/);

        if (!match) return false;

        if (!silent) {
            const token = state.push('block_math', 'div', 0);
            token.content = match[1].replace(/\\\\/g, '\\');
            token.map = [startLine, state.line + 1];
            token.markup = match[0];
        }

        state.line = startLine + 1;
        return true;
    });
}
